"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RankPointRequest = void 0;
var RankPointRequest = /** @class */ (function () {
    function RankPointRequest() {
    }
    return RankPointRequest;
}());
exports.RankPointRequest = RankPointRequest;
;
//# sourceMappingURL=rankPoint.request.js.map